import { useQuery } from "@tanstack/react-query";
import type { Product } from "@nh/shared";
import { fetchShopProduct, shopProductQueryKey } from "./shop.api";

/**
 * La ficha de UN producto, por slug.
 *
 * ── Por qué no se saca del catálogo que ya está en caché ─────────────
 * Sería tentador: la tienda ya trajo los cien productos y el que se busca
 * está ahí. Pero entonces entrar por un enlace compartido —sin haber
 * pasado por la tienda— pediría el catálogo entero para pintar una ficha,
 * y el 404 de un producto despublicado dependería de que la lista
 * estuviera fresca. Esta consulta le pregunta al servidor por ese
 * producto, que es quien sabe si está publicado AHORA.
 *
 * La política de reintentos vive en el `QueryClient` (`app/providers.tsx`)
 * y ya excluye `NOT_FOUND`: un producto que no existe no aparece por
 * insistir, y reintentarlo solo alarga la espera antes de enseñar el
 * mensaje.
 */
export function useShopProduct(slug: string) {
  return useQuery<{ product: Product }>({
    queryKey: shopProductQueryKey(slug),
    queryFn: () => fetchShopProduct(slug),
  });
}
